import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { IDS } from "../../utils/IDS";
import { Select2Data } from "../../utils/common";

export const AllUsers = createAsyncThunk(
  "common/managepoints/receviables",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.User}`);
      //  console.log(res, "All AllUsers data");
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "user",
  initialState: {
    data: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllUsers.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUsers.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload || [];
      })
      .addCase(AllUsers.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
